import { c as _c } from "react/compiler-runtime";
import React from "react";
interface PinnedWavesScrollButtonProps {
  readonly direction: "left" | "right";
  readonly onClick: () => void;
}
const PinnedWavesScrollButton: React.FC<PinnedWavesScrollButtonProps> = t0 => {
  const $ = _c(8);
  const {
    direction,
    onClick
  } = t0;
  const isLeft = direction === "left";
  const t1 = isLeft ? "Scroll left" : "Scroll right";
  const t2 = `tw-group tw-absolute tw-top-0 tw-z-10 tw-inline-flex tw-size-8 tw-items-center tw-justify-center tw-rounded-md tw-border-none tw-bg-iron-700 tw-p-0 tw-ring-1 tw-ring-inset tw-ring-white/10 sm:tw-top-0.5 sm:tw-size-7 ${isLeft ? "tw-left-0" : "tw-right-0"}`;
  const t3 = `tw-size-5 tw-text-iron-200 tw-transition tw-duration-300 tw-ease-out group-hover:tw-text-iron-400 sm:tw-size-4 ${isLeft ? "tw-rotate-90" : "-tw-rotate-90"}`;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />;
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  let t5;
  if ($[1] !== t3) {
    t5 = <svg className={t3} viewBox="0 0 24 24" fill="none" aria-hidden="true">{t4}</svg>;
    $[1] = t3;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== onClick || $[4] !== t1 || $[5] !== t2 || $[6] !== t5) {
    t6 = <button type="button" aria-label={t1} onClick={onClick} className={t2}>{t5}</button>;
    $[3] = onClick;
    $[4] = t1;
    $[5] = t2;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  return t6;
};
export default PinnedWavesScrollButton;